import { InlineBoxType } from '$/components/InlineBox/types';
import { EditorSerializedContent } from './types';

const mapInlineTypeToTag = (type: InlineBoxType, mediaType?: string): string => {
  switch (type) {
    case InlineBoxType.Image:
      return 'input_image';
    case InlineBoxType.Video:
      return 'input_video';
    case InlineBoxType.File:
      return 'input_file';
    case InlineBoxType.Skill:
      return 'input_skill';
    case InlineBoxType.Mark:
      return mediaType || 'image';
    default:
      return String(type);
  }
};

/** 将结构化编辑器内容序列化为后端约定的 inline tag 文本。 */
export const serializeContentToInlineText = (content: EditorSerializedContent): string => {
  return content.map((fragment) => {
    if (fragment.type === 'text') return fragment.value;
    if (fragment.type === 'mention') return `[@agent:${fragment.value.id}]`;
    const inlineBox = fragment.value;
    const tag = inlineBox.data.tag || mapInlineTypeToTag(inlineBox.type as InlineBoxType, inlineBox.data.mediaType);
    const serial = inlineBox.type === InlineBoxType.Mark
      ? `:#${inlineBox.data.order ?? ''}`
      : '';
    const index = inlineBox.data.index || '';
    return `[@${tag}${serial}:${index}]`;
  }).join('');
};
